<template>
  <div class="work_index">
     <div class="work_index_top">
          工作通
     </div>

     <div class="work_index_item">
            <p>通讯录</p>
            <ul>
               <router-link class="work_option"  to="/director-workmaster-contacts">
                    <img src="@/assets/personal-work-img/申请提拔@2x.png">
                    <div>通讯录管理</div>
               </router-link> 
            </ul>
      </div>

      <div class="work_index_item">
            <p>应用管理</p>
            <ul>
               <router-link class="work_option"  to="/director-workmaster-clock">
                    <img  src="@/assets/work/qingjia.png">
                    <div>打卡</div>
               </router-link> 
               <router-link class="work_option"  to="/director-workmaster-approval">
                    <img  src="@/assets/work/chuchai.png">
                    <div>审批</div>
               </router-link> 
               <router-link class="work_option"  to="/director-workmaster-report">
                    <img src="@/assets/work/zhanbao.png">
                    <div>汇报</div>
               </router-link> 
            </ul>
      </div>


  </div>
</template>

<script>
export default{
  
    data(){
          return{
            
          };
    }
}

</script>

<style lang="scss" scoped>
.work_index{
    width: 1200px;
    margin: 0 auto;
}
.work_index_top{
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    font-weight: bolder;
    border-bottom: 1px solid #CCCCCC;
}

.work_index_item{
      margin-top: 38px;
 }
 .work_index_item ul{
      margin-top: 23px;
      display: flex;
 }
 .work_index_item ul .work_option{
      width: 180px;
      height: 60px;
      margin-right: 19px;
      border: 1px solid #CCCCCC;
      border-radius: 10px;
      display: flex;
 }
 .work_index_item ul .work_option img{
      height: 39px;
      width: 39px;
      margin-top: 11px;
      margin-left: 13px;
 }
 .work_index_item ul .work_option div{
      margin-left: 20px;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: 500;
      user-select:none;
      color: #181818;
 }
</style>